import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import styles from './Article.scss'
import { sharedMessages } from '../intlMessages'
import { ShowPageContainer } from 'features/ride_reports/ShowPage'
import { formatDate } from 'features/ride_reports/ShowPage/Nav'
import { rideReportActions, rideReportSelectors } from 'data/resources/rideReports'
import { Navbar, NavbarGroup, NavbarTitle } from 'common/Navbar'
import { Loadable } from 'common/Loadable'
import { Msg, featureNames } from 'lib/localization'
import { softError } from 'lib/softError'
import { FormattedMessage as T, injectIntl } from 'react-intl'

const getTypeFromPath = path => {
  const m = path.match(/\/(.*)\//)
  return m && m.pop()
}

class _JournalArticle extends React.PureComponent {
  render () {
    const { article, ...others } = this.props

    return (
      <ShowPageContainer {...others} reportId={article.id} journalArticle OverwriteNav={<JournalNav article={article} />} />
    )
  }
}

class _NewsArticle extends React.PureComponent {
  render () {
    const { article, ...others } = this.props

    return (
      <ShowPageContainer
        {...others}
        reportId={article.id}
        newsArticle
        OverwriteNav={<NewsNav article={article} />}
      />
    )
  }
}

const JournalNav = ({ article }) => (
  <Navbar>
    <NavbarGroup>
      <li><NavbarTitle to='/journal'><Msg m={featureNames.journal} /></NavbarTitle></li>
      <li><T id='journalMessages.storyBy' defaultMessage='story by' /> <Link to={article.authorUrl} className={styles.authorLink}>{article.authorByline}</Link></li>
      <li className={styles.collapse}>{formatDate(article.publishedAt)}</li>
    </NavbarGroup>
  </Navbar>
)

const NewsNav = ({ article }) => (
  <Navbar>
    <NavbarGroup>
      <li><NavbarTitle to='/news'><Msg m={featureNames.newsAndPress} /></NavbarTitle></li>
      <li><T id='newsMessages.postedBy' defaultMessage='posted by' /> Ride with GPS</li>
      <li className={styles.collapse}>{formatDate(article.publishedAt)}</li>
    </NavbarGroup>
  </Navbar>
)

const loadInitialData = ({ loadJournal, loadNews, route }) => {
  let action
  switch (getTypeFromPath(route.path)) {
    case 'journal':
      action = loadJournal
      break
    case 'news':
      action = loadNews
      break
    default:
      softError('<Article /> only works with news/journal ride reports')
  }
  return Promise.all([action()])
}

const LoadableArticle = (props) => <Loadable
  {...props}
  component={getTypeFromPath(props.route.path) === 'journal' ? _JournalArticle : _NewsArticle}
  loadingText={<Msg m={sharedMessages.loadingArticle} />}
  resourceLoaded={() => loadInitialData(props)} />

export const IntlArticle = injectIntl(LoadableArticle)

const mapStateToProps = (state, ownProps) => {
  const slug = ownProps.params.slug
  const reportId = parseInt(slug, 10)

  return {
    article: rideReportSelectors.find(state, reportId)
  }
}

export const Article = connect(
  mapStateToProps,
  {
    loadJournal: rideReportActions.journal,
    loadNews: rideReportActions.news
  }
)(IntlArticle)
